import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../../theme'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        marginHorizontal: 8,
    },
    containerFlex: {
        flex: 1,
    },
    flatList: {
        flex: 1,
        flexGrow: 1,
        marginLeft: -8,
    },
    containerNoResults: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    containerInput: {
        marginHorizontal: 10,
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 10,
    },
    input: {
        flex: 1,
        fontSize: 15,
        color: theme.colors.textPrimary,
    },
    containerFinder: {
        paddingHorizontal: 4,
    },
    inputBlock: {
        flexDirection: 'row',
        width: '100%',
        height: 40,
        borderWidth: 0.5,
        borderRadius: 10,
        borderColor: theme.colors.mediumGray,
        backgroundColor: 'white',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 20,
        marginVertical: 10,
    },
    image: {
        width: 120,
        height: 120,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 40,
    },
    description: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 40,
    },
    containerLoading: {
        flexDirection: 'row',
        paddingHorizontal: 6,
        paddingTop: 4,
        paddingBottom: 8,
    },
    loading: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.mediumGray,
        textAlign: 'left',
    },
})

export default styles
